import { Language } from '@sparemin/api-sdk';

/**
 * Allows inferring a language from a partial lang value.
 * There an scenario in which backend might return a non complete language code,
 * for example "es". This util will iterate over the available supported languages
 * and return the first found lang that hits a partial match.
 */
export const inferLanguage = (
  supportedLanguages?: Language[],
  partialLang?: string,
): string | undefined => {
  if (!partialLang) {
    return undefined;
  }

  return supportedLanguages?.find(lang =>
    lang.languageCode.toLowerCase().includes(partialLang.toLowerCase()),
  ).languageCode;
};
